<template>
  <div>
    <h3 class="title-content" v-if="!isModal">Meu Perfil</h3>
    <v-card class="form-card">
      <v-form ref="formProfile">
        <v-row>
          <v-col cols="6" sm="6">
            <v-text-field
                v-model="user.name"
                :rules="rules.name"
                label="Nome Completo">
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
                disabled
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="user.identification"
                :rules="rules.identification"
                label="CPF/CNPJ">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                v-mask="['(##) ####-####', '(##) #####-####']"
                v-model="user.phone"
                :rules="rules.phone"
                label="Celular">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
                ref="menu"
                v-model="showBirthDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFormatted"
                    label="Data de nascimento"
                    persistent-hint
                    v-bind="attrs"
                    maxlength="10"
                    hint="dd/mm/aaaa"
                    @blur="user.birth_date = parseDate(dateFormatted)"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="user.birth_date"
                  no-title
                  scrollable
                  @input="showBirthDatePicker = false"
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="showBirthDatePicker = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(user.birth_date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field
                :rules="rules.email"
                v-model="user.email"
                label="E-mail">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="12">
            <v-alert type="error" color="#e72c1f" v-if="errorMsg !== null && errorMsg.length > 0">{{
                errorMsg
              }}
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field
                v-model="user.cep"
                :rules="rules.cep"
                v-mask="['#####-###']"
                @blur="searchCep"
                label="CEP"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="user.address"
                :rules="rules.address"
                required
                label="Endereço"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="user.complement"
                label="Complemento"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="user.number"
                :rules="rules.number"
                required
                v-mask="['#####']"
                label="Nº"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="user.district"
                :rules="rules.district"
                required
                label="Bairro"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="user.city"
                :rules="rules.city"
                required
                label="Cidade"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="user.uf"
                :rules="rules.uf"
                required
                @keyup="user.uf = user.uf.toUpperCase()"
                v-mask="['SS']"
                label="Estado"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                type="password"
                :rules="rules.password"
                v-model="user.password"
                label="Senha">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                type="password"
                :rules="rules.password_confirmation"
                v-model="user.password_confirmation"
                label="Confirmar Senha">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-alert class="col-12"
                   v-if="update"
                   type="success">
            Seu perfil foi atualizado com sucesso.
          </v-alert>
        </v-row>
        <v-row>
          <v-btn @click.prevent="showDeleteWarningDialog"
                 class="btn-cancel mr-2">
            Excluir Conta
          </v-btn>
          <v-btn @click.prevent="requestDataDeletion"
                 class="btn-cancel mr-auto">
            Solicitar exclusão de dados pessoais
          </v-btn>
          <v-btn @click.prevent="handleCancel"
                 class="btn-cancel">
            Cancelar
          </v-btn>
          <v-btn @click.prevent="editProfile()"
                 class="btn-confirm">
            Atualizar Dados
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
    <delete-account-warning-dialog
        :show="showWarningDialog"
        @cancel="showWarningDialog = false"
        @continue="proceedToDeleteConfirmation"
    />
    <delete-account-dialog
        :show="showConfirmDialog"
        :balance="walletBalance"
        :allows-refund="supportConfig && supportConfig.allowsRefund"
        @cancel="showConfirmDialog = false"
        @delete="handleDeleteAccount"
        @refund="handleRequestRefund"
    />
    <generic-error-dialog-v2
        v-model="errorDialogText"
        :error-text="errorDialogText"
    />
    <generic-success-dialog
        v-model="showRefundSuccessDialog"
        :success-text="refundSuccessMessage"
        title="Sucesso"
        button-text="OK"
        @close="handleRefundSuccessClose"
    />
    <generic-success-dialog
        v-model="showDeleteSuccessDialog"
        success-text="Conta excluída com sucesso, você será redirecionado para a tela inicial"
        title="Conta Excluída"
        button-text="Confirmar"
        @close="logout"
    />
    <generic-success-dialog
        v-model="showDataDeletionSuccessDialog"
        :success-text="dataDeletionSuccessMessage"
        title="Solicitação Registrada"
        button-text="OK"
        @close="showDataDeletionSuccessDialog = false"
    />
    <confirmation-alert
        v-model="showDataDeletionConfirmDialog"
        title="Confirmar Solicitação"
        messages="Tem certeza que deseja solicitar a exclusão dos seus dados pessoais? Esta ação iniciará um processo de análise."
        confirm-text="Sim, solicitar"
        cancel-text="Cancelar"
        @cancel="showDataDeletionConfirmDialog = false"
        @confirm="confirmDataDeletion"
    />
  </div>
</template>

<script>
import moment from "moment/moment";
import axios from "axios";
import DeleteAccountDialog from "@/components/DeleteAccountDialog.vue";
import DeleteAccountWarningDialog from "@/components/DeleteAccountWarningDialog.vue";
import GenericErrorDialogV2 from "@/components/GenericErrorDialogV2.vue";
import GenericSuccessDialog from "@/components/GenericSuccessDialog.vue";
import ConfirmationAlert from "@/components/Alerts/ConfirmationAlert.vue";

export default {
  name: "Profile",
  components: {
    DeleteAccountDialog,
    DeleteAccountWarningDialog,
    GenericErrorDialogV2,
    GenericSuccessDialog,
    ConfirmationAlert
  },
  props: {
    errorMsg: {
      type: String,
      default: '',
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showBirthDatePicker: false,
      dateFormatted: '',
      loading: false,
      user: {
        id: null,
        name: '',
        identification: '',
        email: '',
        phone: '',
        birth_date: '',
        cep: '',
        address: '',
        complement: '',
        number: '',
        district: '',
        city: '',
        uf: '',
      },
      update: false,
      walletBalance: 0,
      showWarningDialog: false,
      showConfirmDialog: false,
      errorDialogText: null,
      showRefundSuccessDialog: false,
      showDeleteSuccessDialog: false,
      showDataDeletionSuccessDialog: false,
      showDataDeletionConfirmDialog: false,
      refundSuccessMessage: "Pedido de Reembolso solicitado com sucesso! Aguarde até receber a resposta por email desse atendimento. Verifique se o nosso email de resposta não está na sua caixa de SPAM ou lixo eletrônico.",
      dataDeletionSuccessMessage: "Sua solicitação de exclusão de dados pessoais foi registrada e encaminhada ao Encarregado de Proteção de Dados (DPO) para análise, nos termos da Lei nº 13.709/2018 (LGPD).",
      rules: {
        name: [
          value => (value || '').length > 0 || 'O campo nome é obrigatório',
          value => this.isNameValid(value) || 'Digite o seu nome completo'
        ],
        phone: [
          value => ((value || '').length > 0 || this.user.email.length > 0) || 'O campo celular é obrigatório',
        ],
        email: [
          value => (value.length > 0 || this.user.phone.length > 0) || 'O campo e-mail é obrigatório',
        ],
        password: [
          value => ((value || '') === '') || (value || '').length >= 6 || 'A senha deve conter pelo menos 6 caracteres',
        ],
        password_confirmation: [
          value => (value === this.user.password) || 'O campo de confirmação de senha esta diferente',
        ],
        cep: [
          value => (value || '').length > 0 || 'O campo cep é obrigatório',
          value => (value || '').length > 8 || 'Digite o cep',
        ],
        address: [
          value => (value || '').length > 0 || 'O campo endereço é obrigatório',
          value => (value || '').length > 3 || 'Digite o endereço',
        ],
        number: [value => (value || '').length > 0 || 'O campo número é obrigatório',],
        district: [value => (value || '').length > 0 || 'O campo bairro é obrigatório',],
        uf: [value => (value || '').length > 1 || 'O campo estado é obrigatório',],
        city: [value => (value || '').length > 0 || 'O campo cidade é obrigatório',],
      }
    }
  },
  mounted() {
    this.fetchUserData();
    this.fetchWalletBalance();
  },
  computed: {
    supportConfig() {
      return this.$store.getters['user/support'];
    },
    userData() {
      return this.$store.getters['user/userData'];
    },
    hasRecentRefundRequest() {
      if (this.userData && this.userData.requested_refund_date) {
        const requestDate = new Date(this.userData.requested_refund_date);
        const now         = new Date();
        const daysDiff    = Math.floor((now.getTime() - requestDate.getTime()) / (1000 * 60 * 60 * 24));
        return daysDiff < 3;
      }
      return false;
    },
    refundRequestDate() {
      if (this.userData && this.userData.requested_refund_date) {
        const date = new Date(this.userData.requested_refund_date);
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      return '';
    }
  },
  methods: {
    async fetchUserData() {
      try {
        const {data}             = await axios.get('/api/users/driver/me');
        this.user.id             = data.user.id;
        this.user.name           = data.user.name;
        this.user.identification = this.identificationToPattern(data.user.identification);
        this.user.phone          = this.phoneToPattern(data.user.phone);
        this.user.email          = data.user.email;

        const birth_date     = new Date(data.birth_date);
        this.user.birth_date = moment(birth_date).format('YYYY-MM-DD');

        if (data.user.address) {
          const address                                  = JSON.parse(data.user.address);
          let [street, street_number, street_complement] = address.address.split(',');
          this.user.address                              = street;
          this.user.cep                                  = this.user.cep ? `${address.cep.substring(0, 5)}-${address.cep.substring(5)}` : null;
          this.user.city                                 = address.city;
          this.user.complement                           = street_complement ? street_complement : '';
          this.user.district                             = address.district;
          this.user.number                               = street_number;
          this.user.uf                                   = address.uf;
        }
      } catch (error) {
        this.showError('Erro ao carregar dados do usuário');
      }
    },
    async fetchWalletBalance() {
      try {
        const {data} = await axios.get('/api/users/my/wallets');
        if (data && data.length > 0) {
          this.walletBalance = data[0].balance_credit || 0;
        }
      } catch (error) {
        this.showError('Erro ao carregar saldo da carteira');
      }
    },
    async deleteDriver(force) {
      const driverId = JSON.parse(localStorage.getItem('user')).driver_id;
      return axios.delete(`/api/users/driver/${driverId}`, {
        data: {force}
      }).then(response => response.data);
    },
    async requestRefund() {
      return axios.post('/api/users/me/refund-request')
          .then(response => response.data);
    },
    showError(text) {
      this.errorDialogText = text;
    },
    handleRefundSuccessClose() {
      if (this.$props.isModal) {
        this.$emit('continue-action');
      } else {
        this.$router.push({name: 'home'});
      }
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) {
        return null;
      }
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getOnlyNumbers: function (string) {
      return string.replace(/[^0-9]/g, '');
    },
    isNameValid: function (value) {
      const pattern = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;
      const split   = value.split(' ');
      return value.includes(' ') && value.length > 6 && split[1].length > 1 && pattern.test(value)
    },
    searchCep: function () {
      if (this.user.cep && this.user.cep.length === 9) {
        this.$viaCep.buscarCep(this.user.cep).then((obj) => {
          this.user.address  = obj.logradouro;
          this.user.city     = obj.localidade;
          this.user.district = obj.bairro;
          this.user.uf       = obj.uf;
        });
      }
    },
    formatStringToRequest(text, format = undefined) {
      return text ? (format ? format(text) : text) : undefined;
    },
    async shouldUpdateAddress(new_address) {
      const original_address = await axios.get('/api/user').then(res => {
        if (res.data.address) {
          return JSON.parse(res.data.address);
        }
        return {};
      });

      return original_address.address !== new_address.address ||
          original_address.cep !== new_address.cep ||
          original_address.city !== new_address.city ||
          original_address.district !== new_address.district ||
          original_address.uf !== new_address.uf;
    },
    getAddressObj() {
      return {
        address: this.user.address,
        cep: this.user.cep,
        city: this.user.city,
        complement: this.user.complement,
        district: this.user.district,
        number: this.user.number,
        uf: this.user.uf,
      }
    },
    formatAddressToStore(addressToFormat) {
      let address = `${addressToFormat.address},${addressToFormat.number}`
      if (addressToFormat.complement) {
        address += `,${addressToFormat.complement}`
      }
      return {
        address,
        district: addressToFormat.district,
        city: addressToFormat.city,
        uf: addressToFormat.uf,
        cep: addressToFormat.cep.replace(/[^0-9]/g, ''),
      }
    },
    editProfile: async function () {
      if (this.$refs.formProfile.validate()) {
        this.loading = true;

        const birthDateInUTC          = new Date(this.user.birth_date);
        const userTimezoneOffset      = new Date().getTimezoneOffset() / 60;
        const birthDateInUserTimezone = new Date(
            birthDateInUTC.getTime() + userTimezoneOffset * 60 * 60 * 1000
        );

        const year  = birthDateInUserTimezone.getFullYear();
        const month = String(birthDateInUserTimezone.getMonth() + 1).padStart(
            2,
            '0',
        );
        const day   = String(birthDateInUserTimezone.getDate()).padStart(2, '0');

        const birth_date_formatted = `${year}-${month}-${day}`;

        const driver = {
          name: this.formatStringToRequest(this.user.name),
          phone: this.formatStringToRequest(this.user.phone, this.getOnlyNumbers),
          identification: this.formatStringToRequest(this.user.identification, this.getOnlyNumbers),
          email: this.formatStringToRequest(this.user.email),
          password: this.formatStringToRequest(this.user.password),
          password_confirmation: this.formatStringToRequest(this.user.password_confirmation),
          birth_date: this.formatStringToRequest(birth_date_formatted),
        };
        try {
          await axios.put('/api/users/driver/me', driver);

          const address = this.formatAddressToStore(this.getAddressObj());
          if (await this.shouldUpdateAddress(address)) {
            await axios.put("/api/users/me/address/change", {address});
          }
          this.update = true;
          if (this.$props.isModal) {
            this.$emit('continue-action');
          }
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error && e.response.data.error.errors) {
            const errorMsg = Object.entries(e.response.data.error.errors)[0][1][0]
                || 'Ocorreu um erro. Tente novamente.';
            this.showError(errorMsg);
          } else {
            this.showError('Ocorreu um erro ao atualizar os dados. Tente novamente.');
          }
        }
        this.loading = false;
      }
    },
    handleCancel: function () {
      if (this.$props.isModal) {
        return this.$emit('continue-action');
      } else {
        this.$router.go(-1);
      }
    },
    showDeleteWarningDialog() {
      if (this.hasRecentRefundRequest) {
        this.showError(`Você já solicitou reembolso em ${this.refundRequestDate}. Por favor, aguarde o retorno da nossa equipe.`);
        return;
      }
      this.showWarningDialog = true;
    },

    proceedToDeleteConfirmation() {
      this.showWarningDialog = false;
      this.showConfirmDialog = true;
    },

    logout() {
      localStorage.removeItem('token');
      location.reload();
    },
    async handleDeleteAccount(force) {
      this.loading           = true;
      this.showConfirmDialog = false;
      try {
        await this.deleteDriver(force);
        this.showDeleteSuccessDialog = true;
      } catch (error) {
        if (error.response && error.response.data) {
          const errorType    = error.response.data.type;
          const errorMessage = error.response.data.message;
          if (errorType === 'UserHasBalance' || errorType === 'UserHasRequestedExclusion') {
            this.showError(errorMessage);
          } else {
            this.showError('Ocorreu um erro ao excluir a conta. Tente novamente.');
          }
        } else {
          this.showError('Ocorreu um erro ao excluir a conta. Tente novamente.');
        }
      } finally {
        this.loading = false;
      }
    },
    async handleRequestRefund() {
      this.loading           = true;
      this.showConfirmDialog = false;

      try {
        await this.requestRefund();
        this.showRefundSuccessDialog = true;
      } catch (error) {
        let errorMsg = 'Ocorreu um erro ao solicitar o reembolso.';
        if (error.response && error.response.data && error.response.data.error) {
          errorMsg = error.response.data.error.message || errorMsg;
        }
        this.showError(errorMsg);
      } finally {
        this.loading = false;
      }
    },
    requestDataDeletion() {
      this.showDataDeletionConfirmDialog = true;
    },
    async confirmDataDeletion() {
      this.showDataDeletionConfirmDialog = false;
      this.loading                       = true;
      try {
        await axios.post(`/api/users/request-personal-data-deletion`);
        this.showDataDeletionSuccessDialog = true;
      } catch (error) {
        this.showError('Ocorreu um erro ao solicitar a exclusão dos dados pessoais.');
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    'user.birth_date': {
      handler() {
        this.dateFormatted = this.formatDate(this.user.birth_date);
      }
    }
  },
}
</script>

<style scoped>
.title-content {
  font-size: 28px;
  font-family: Roboto-Black;
  color: #595959;
  margin-bottom: 20px;
}

.btn-blue {
  text-transform: capitalize !important;
  background: #000 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;

}

.btn-blue:hover {
  background: transparent !important;
  color: #000 !important;
}

@media only screen and (max-width: 500px) {
  .btn-confirm, .btn-cancel {
    width: 100%;
    margin: 5px 0 !important;
    padding: 0;
  }
}
</style>
